const movieGamePuzzles = [
  {
    "clue": [
      "Tokyo",
      "Silence",
      "Regret"
    ],
    "answer": "Lost in Translation",
    "choices": [
      "Lost in Translation",
      "Her",
      "Drive",
      "Before Sunrise"
    ]
  },
  {
    "clue": [
      "Rain",
      "Neon",
      "Loneliness"
    ],
    "answer": "Chungking Express",
    "choices": [
      "Drive",
      "Chungking Express",
      "In the Mood for Love",
      "Heat"
    ]
  },
  {
    "clue": [
      "Memory",
      "Dreams",
      "Snow"
    ],
    "answer": "Eternal Sunshine of the Spotless Mind",
    "choices": [
      "Her",
      "Arrival",
      "Eternal Sunshine of the Spotless Mind",
      "Past Lives"
    ]
  },
  {
    "clue": [
      "Jazz",
      "Night",
      "Taxi"
    ],
    "answer": "Collateral",
    "choices": [
      "Drive",
      "Collateral",
      "Heat",
      "Nightcrawler"
    ]
  },
  {
    "clue": [
      "Desert",
      "Prophecy",
      "Sand"
    ],
    "answer": "Dune",
    "choices": [
      "Dune",
      "Arrival",
      "Blade Runner 2049",
      "The Creator"
    ]
  },
  {
    "clue": [
      "Paris",
      "Midnight",
      "Nostalgia"
    ],
    "answer": "Midnight in Paris",
    "choices": [
      "Before Sunset",
      "Midnight in Paris",
      "Amélie",
      "La La Land"
    ]
  },
  {
    "clue": [
      "Ocean",
      "Isolation",
      "Memory"
    ],
    "answer": "Solaris",
    "choices": [
      "Moon",
      "Solaris",
      "Interstellar",
      "Ad Astra"
    ]
  },
  {
    "clue": [
      "Dreams",
      "Hallway",
      "Spinning"
    ],
    "answer": "Inception",
    "choices": [
      "Inception",
      "Tenet",
      "Memento",
      "The Prestige"
    ]
  },
  {
    "clue": [
      "Neon",
      "Driver",
      "Silence"
    ],
    "answer": "Drive",
    "choices": [
      "Drive",
      "Baby Driver",
      "Heat",
      "Only God Forgives"
    ]
  },
  {
    "clue": [
      "Love",
      "Hong Kong",
      "Noodles"
    ],
    "answer": "In the Mood for Love",
    "choices": [
      "Chungking Express",
      "Past Lives",
      "In the Mood for Love",
      "Her"
    ]
  },
  {
    "clue": [
      "Hotel",
      "Europe",
      "Pastries"
    ],
    "answer": "The Grand Budapest Hotel",
    "choices": [
      "The Grand Budapest Hotel",
      "Amélie",
      "The French Dispatch",
      "Jojo Rabbit"
    ]
  },
  {
    "clue": [
      "Time",
      "Cornfield",
      "Space"
    ],
    "answer": "Interstellar",
    "choices": [
      "Interstellar",
      "Gravity",
      "Arrival",
      "Moon"
    ]
  },
  {
    "clue": [
      "Los Angeles",
      "Actress",
      "Dream"
    ],
    "answer": "Mulholland Drive",
    "choices": [
      "Mulholland Drive",
      "La La Land",
      "Black Swan",
      "Persona"
    ]
  },
  {
    "clue": [
      "Robots",
      "Rain",
      "Humanity"
    ],
    "answer": "Blade Runner",
    "choices": [
      "Blade Runner",
      "Ghost in the Shell",
      "Ex Machina",
      "Upgrade"
    ]
  },
  {
    "clue": [
      "Train",
      "Europe",
      "Conversation"
    ],
    "answer": "Before Sunrise",
    "choices": [
      "Before Sunrise",
      "Lost in Translation",
      "Paterson",
      "Past Lives"
    ]
  },
  {
    "clue": [
      "Apartment",
      "Loneliness",
      "Routine"
    ],
    "answer": "Perfect Days",
    "choices": [
      "Perfect Days",
      "Paterson",
      "Her",
      "Columbus"
    ]
  },
  {
    "clue": [
      "Drums",
      "Obsession",
      "Jazz"
    ],
    "answer": "Whiplash",
    "choices": [
      "Birdman",
      "Whiplash",
      "La La Land",
      "Tár"
    ]
  },
  {
    "clue": [
      "Chess",
      "Winter",
      "Death"
    ],
    "answer": "The Seventh Seal",
    "choices": [
      "The Seventh Seal",
      "Persona",
      "Stalker",
      "Winter Light"
    ]
  },
  {
    "clue": [
      "Suburbia",
      "Plastic",
      "Roses"
    ],
    "answer": "American Beauty",
    "choices": [
      "American Beauty",
      "Revolutionary Road",
      "Little Children",
      "Magnolia"
    ]
  },
  {
    "clue": [
      "Tunnel",
      "Ghosts",
      "Memory"
    ],
    "answer": "Spirited Away",
    "choices": [
      "Spirited Away",
      "Princess Mononoke",
      "Your Name",
      "Paprika"
    ]
  },
  {
    "clue": [
      "Florida",
      "Motel",
      "Childhood"
    ],
    "answer": "The Florida Project",
    "choices": [
      "The Florida Project",
      "Moonlight",
      "Lady Bird",
      "Boyhood"
    ]
  },
  {
    "clue": [
      "Subway",
      "Jazz",
      "Falling"
    ],
    "answer": "La La Land",
    "choices": [
      "La La Land",
      "Babylon",
      "Whiplash",
      "Once"
    ]
  },
  {
    "clue": [
      "Wilderness",
      "Revenge",
      "Bear"
    ],
    "answer": "The Revenant",
    "choices": [
      "The Revenant",
      "The Grey",
      "1917",
      "Apocalypto"
    ]
  },
  {
    "clue": [
      "Computer",
      "Simulation",
      "Reality"
    ],
    "answer": "The Matrix",
    "choices": [
      "The Matrix",
      "Dark City",
      "Upgrade",
      "Inception"
    ]
  },
  {
    "clue": [
      "New York",
      "Writer",
      "Autumn"
    ],
    "answer": "Manhattan",
    "choices": [
      "Manhattan",
      "Annie Hall",
      "Frances Ha",
      "Inside Llewyn Davis"
    ]
  },
  {
    "clue": [
      "Alien",
      "Language",
      "Arrival"
    ],
    "answer": "Arrival",
    "choices": [
      "Arrival",
      "Contact",
      "Interstellar",
      "Annihilation"
    ]
  },
  {
    "clue": [
      "Forest",
      "Zone",
      "Silence"
    ],
    "answer": "Stalker",
    "choices": [
      "Stalker",
      "Solaris",
      "The Mirror",
      "Possession"
    ]
  },
  {
    "clue": [
      "Moon",
      "Clone",
      "Isolation"
    ],
    "answer": "Moon",
    "choices": [
      "Moon",
      "Ad Astra",
      "Solaris",
      "Gravity"
    ]
  },
  {
    "clue": [
      "Family",
      "Tokyo",
      "Stillness"
    ],
    "answer": "Tokyo Story",
    "choices": [
      "Tokyo Story",
      "Shoplifters",
      "Perfect Days",
      "After Life"
    ]
  },
  {
    "clue": [
      "Diner",
      "Hitmen",
      "Dance"
    ],
    "answer": "Pulp Fiction",
    "choices": [
      "Pulp Fiction",
      "Reservoir Dogs",
      "Jackie Brown",
      "Snatch"
    ]
  },
  {
    "clue": [
      "Journalism",
      "Church",
      "Investigation"
    ],
    "answer": "Spotlight",
    "choices": [
      "Spotlight",
      "Zodiac",
      "The Post",
      "All the President's Men"
    ]
  },
  {
    "clue": [
      "Snow",
      "Hotel",
      "Madness"
    ],
    "answer": "The Shining",
    "choices": [
      "The Shining",
      "Doctor Sleep",
      "Hereditary",
      "Misery"
    ]
  },
  {
    "clue": [
      "Memories",
      "Italy",
      "Cinema"
    ],
    "answer": "Cinema Paradiso",
    "choices": [
      "Cinema Paradiso",
      "8½",
      "The Fabelmans",
      "Belfast"
    ]
  },
  {
    "clue": [
      "Apartment",
      "Operator",
      "Loneliness"
    ],
    "answer": "Her",
    "choices": [
      "Her",
      "Lost in Translation",
      "Past Lives",
      "Ex Machina"
    ]
  },
  {
    "clue": [
      "Despair",
      "Ballet",
      "Mirror"
    ],
    "answer": "Black Swan",
    "choices": [
      "Black Swan",
      "Whiplash",
      "Perfect Blue",
      "Tár"
    ]
  },
  {
    "clue": [
      "Family",
      "Basement",
      "Rainstorm"
    ],
    "answer": "Parasite",
    "choices": [
      "Parasite",
      "Burning",
      "Shoplifters",
      "Memories of Murder"
    ]
  },
  {
    "clue": [
      "Lighthouse",
      "Seagulls",
      "Madness"
    ],
    "answer": "The Lighthouse",
    "choices": [
      "The Lighthouse",
      "The Witch",
      "The Northman",
      "Midsommar"
    ]
  },
  {
    "clue": [
      "Summer",
      "Cult",
      "Flowers"
    ],
    "answer": "Midsommar",
    "choices": [
      "Hereditary",
      "Midsommar",
      "The Witch",
      "Suspiria"
    ]
  },
  {
    "clue": [
      "Grief",
      "Dollhouse",
      "Fire"
    ],
    "answer": "Hereditary",
    "choices": [
      "Hereditary",
      "The Babadook",
      "Talk to Me",
      "Saint Maud"
    ]
  },
  {
    "clue": [
      "Witch",
      "Forest",
      "Goat"
    ],
    "answer": "The Witch",
    "choices": [
      "The Witch",
      "Midsommar",
      "The Lighthouse",
      "Hagazussa"
    ]
  },
  {
    "clue": [
      "Dance",
      "Berlin",
      "Witches"
    ],
    "answer": "Suspiria",
    "choices": [
      "Suspiria",
      "Black Swan",
      "Climax",
      "Possession"
    ]
  },
  {
    "clue": [
      "Pregnancy",
      "Apartment",
      "Paranoia"
    ],
    "answer": "Rosemary's Baby",
    "choices": [
      "Rosemary's Baby",
      "Repulsion",
      "The Omen",
      "The Exorcist"
    ]
  },
  {
    "clue": [
      "Prom",
      "Blood",
      "Telekinesis"
    ],
    "answer": "Carrie",
    "choices": [
      "Carrie",
      "Suspiria",
      "The Craft",
      "Raw"
    ]
  },
  {
    "clue": [
      "Cannibal",
      "Coming-of-age",
      "Meat"
    ],
    "answer": "Raw",
    "choices": [
      "Raw",
      "Titane",
      "Bones and All",
      "Possessor"
    ]
  },
  {
    "clue": [
      "Metal",
      "Car",
      "Body"
    ],
    "answer": "Titane",
    "choices": [
      "Titane",
      "Raw",
      "Crash",
      "Possessor"
    ]
  },
  {
    "clue": [
      "Skin",
      "Undercover",
      "Scotland"
    ],
    "answer": "Under the Skin",
    "choices": [
      "Under the Skin",
      "Annihilation",
      "Ex Machina",
      "Species"
    ]
  },
  {
    "clue": [
      "Shimmer",
      "Biology",
      "Lighthouse"
    ],
    "answer": "Annihilation",
    "choices": [
      "Annihilation",
      "Arrival",
      "Under the Skin",
      "Stalker"
    ]
  },
  {
    "clue": [
      "Robot",
      "Mansion",
      "Desire"
    ],
    "answer": "Ex Machina",
    "choices": [
      "Ex Machina",
      "Her",
      "Blade Runner 2049",
      "A.I. Artificial Intelligence"
    ]
  },
  {
    "clue": [
      "Cyberpunk",
      "Snow",
      "Memory"
    ],
    "answer": "Blade Runner 2049",
    "choices": [
      "Blade Runner 2049",
      "Dune",
      "Arrival",
      "Ex Machina"
    ]
  },
  {
    "clue": [
      "Anime",
      "Hacker",
      "Shell"
    ],
    "answer": "Ghost in the Shell",
    "choices": [
      "Ghost in the Shell",
      "Akira",
      "Paprika",
      "Perfect Blue"
    ]
  },
  {
    "clue": [
      "Motorcycle",
      "Neo-Tokyo",
      "Explosion"
    ],
    "answer": "Akira",
    "choices": [
      "Akira",
      "Ghost in the Shell",
      "Paprika",
      "Metropolis"
    ]
  },
  {
    "clue": [
      "Dream",
      "Detective",
      "Parade"
    ],
    "answer": "Paprika",
    "choices": [
      "Paprika",
      "Perfect Blue",
      "Millennium Actress",
      "Spirited Away"
    ]
  },
  {
    "clue": [
      "Pop Idol",
      "Stalker",
      "Mirror"
    ],
    "answer": "Perfect Blue",
    "choices": [
      "Perfect Blue",
      "Paprika",
      "Black Swan",
      "Millennium Actress"
    ]
  },
  {
    "clue": [
      "Actress",
      "Memory",
      "Cinema"
    ],
    "answer": "Millennium Actress",
    "choices": [
      "Millennium Actress",
      "Perfect Blue",
      "Paprika",
      "Tokyo Godfathers"
    ]
  },
  {
    "clue": [
      "Christmas",
      "Tokyo",
      "Found Family"
    ],
    "answer": "Tokyo Godfathers",
    "choices": [
      "Tokyo Godfathers",
      "Shoplifters",
      "After Life",
      "Nobody Knows"
    ]
  },
  {
    "clue": [
      "Family",
      "Theft",
      "Warmth"
    ],
    "answer": "Shoplifters",
    "choices": [
      "Shoplifters",
      "Nobody Knows",
      "Broker",
      "Like Father, Like Son"
    ]
  },
  {
    "clue": [
      "Children",
      "Apartment",
      "Abandonment"
    ],
    "answer": "Nobody Knows",
    "choices": [
      "Nobody Knows",
      "Shoplifters",
      "Broker",
      "After Life"
    ]
  },
  {
    "clue": [
      "Afterlife",
      "Memory",
      "Room"
    ],
    "answer": "After Life",
    "choices": [
      "After Life",
      "Departures",
      "Tokyo Story",
      "Still Walking"
    ]
  },
  {
    "clue": [
      "Violin",
      "Death",
      "Ritual"
    ],
    "answer": "Departures",
    "choices": [
      "Departures",
      "After Life",
      "Ikiru",
      "Drive My Car"
    ]
  },
  {
    "clue": [
      "Red Saab",
      "Theater",
      "Grief"
    ],
    "answer": "Drive My Car",
    "choices": [
      "Drive My Car",
      "Burning",
      "Past Lives",
      "Happy Hour"
    ]
  },
  {
    "clue": [
      "Barn",
      "Cat",
      "Mystery"
    ],
    "answer": "Burning",
    "choices": [
      "Burning",
      "Parasite",
      "Memories of Murder",
      "Decision to Leave"
    ]
  },
  {
    "clue": [
      "Detective",
      "Mountain",
      "Sea"
    ],
    "answer": "Decision to Leave",
    "choices": [
      "Decision to Leave",
      "Memories of Murder",
      "The Handmaiden",
      "Oldboy"
    ]
  },
  {
    "clue": [
      "Revenge",
      "Hallway",
      "Hammer"
    ],
    "answer": "Oldboy",
    "choices": [
      "Oldboy",
      "I Saw the Devil",
      "The Chaser",
      "The Handmaiden"
    ]
  },
  {
    "clue": [
      "Mansion",
      "Maid",
      "Manuscript"
    ],
    "answer": "The Handmaiden",
    "choices": [
      "The Handmaiden",
      "Decision to Leave",
      "Portrait of a Lady on Fire",
      "Carol"
    ]
  },
  {
    "clue": [
      "Island",
      "Painting",
      "Desire"
    ],
    "answer": "Portrait of a Lady on Fire",
    "choices": [
      "Portrait of a Lady on Fire",
      "Carol",
      "Blue Is the Warmest Colour",
      "The Piano"
    ]
  },
  {
    "clue": [
      "Gloves",
      "Department Store",
      "Desire"
    ],
    "answer": "Carol",
    "choices": [
      "Carol",
      "Far from Heaven",
      "Portrait of a Lady on Fire",
      "A Single Man"
    ]
  },
  {
    "clue": [
      "Grief",
      "Fashion",
      "Glasses"
    ],
    "answer": "A Single Man",
    "choices": [
      "A Single Man",
      "Carol",
      "Moonlight",
      "Call Me by Your Name"
    ]
  },
  {
    "clue": [
      "Peaches",
      "Summer",
      "Italy"
    ],
    "answer": "Call Me by Your Name",
    "choices": [
      "Call Me by Your Name",
      "Before Sunrise",
      "Aftersun",
      "The Dreamers"
    ]
  },
  {
    "clue": [
      "Father",
      "Daughter",
      "Holiday"
    ],
    "answer": "Aftersun",
    "choices": [
      "Aftersun",
      "Past Lives",
      "The Florida Project",
      "Boyhood"
    ]
  },
  {
    "clue": [
      "Childhood",
      "Texas",
      "Years"
    ],
    "answer": "Boyhood",
    "choices": [
      "Boyhood",
      "The Tree of Life",
      "Aftersun",
      "Lady Bird"
    ]
  },
  {
    "clue": [
      "Sacramento",
      "Mother",
      "Daughter"
    ],
    "answer": "Lady Bird",
    "choices": [
      "Lady Bird",
      "Frances Ha",
      "Eighth Grade",
      "Little Women"
    ]
  },
  {
    "clue": [
      "Brooklyn",
      "Dancer",
      "Friendship"
    ],
    "answer": "Frances Ha",
    "choices": [
      "Frances Ha",
      "Lady Bird",
      "Mistress America",
      "Girls"
    ]
  },
  {
    "clue": [
      "Internet",
      "Anxiety",
      "Middle School"
    ],
    "answer": "Eighth Grade",
    "choices": [
      "Eighth Grade",
      "Lady Bird",
      "Booksmart",
      "The Edge of Seventeen"
    ]
  },
  {
    "clue": [
      "Sisters",
      "Writing",
      "Civil War"
    ],
    "answer": "Little Women",
    "choices": [
      "Little Women",
      "Pride & Prejudice",
      "Emma.",
      "Atonement"
    ]
  },
  {
    "clue": [
      "Green Dress",
      "Letter",
      "War"
    ],
    "answer": "Atonement",
    "choices": [
      "Atonement",
      "Pride & Prejudice",
      "Anna Karenina",
      "The English Patient"
    ]
  },
  {
    "clue": [
      "Moor",
      "Mansion",
      "Piano"
    ],
    "answer": "The Piano",
    "choices": [
      "The Piano",
      "Jane Eyre",
      "Bright Star",
      "Portrait of a Lady on Fire"
    ]
  },
  {
    "clue": [
      "Poetry",
      "Illness",
      "Romance"
    ],
    "answer": "Bright Star",
    "choices": [
      "Bright Star",
      "The Piano",
      "Atonement",
      "Jane Eyre"
    ]
  },
  {
    "clue": [
      "Fog",
      "Estate",
      "Governess"
    ],
    "answer": "Jane Eyre",
    "choices": [
      "Jane Eyre",
      "Rebecca",
      "Wuthering Heights",
      "Crimson Peak"
    ]
  },
  {
    "clue": [
      "Manderley",
      "Memory",
      "Secret"
    ],
    "answer": "Rebecca",
    "choices": [
      "Rebecca",
      "Jane Eyre",
      "Crimson Peak",
      "Gaslight"
    ]
  },
  {
    "clue": [
      "Gothic",
      "House",
      "Red Clay"
    ],
    "answer": "Crimson Peak",
    "choices": [
      "Crimson Peak",
      "Rebecca",
      "The Others",
      "Sleepy Hollow"
    ]
  },
  {
    "clue": [
      "Mansion",
      "Children",
      "Ghosts"
    ],
    "answer": "The Others",
    "choices": [
      "The Others",
      "Crimson Peak",
      "The Sixth Sense",
      "The Orphanage"
    ]
  },
  {
    "clue": [
      "Ghost Boy",
      "Red",
      "Secret"
    ],
    "answer": "The Sixth Sense",
    "choices": [
      "The Sixth Sense",
      "The Others",
      "Signs",
      "Unbreakable"
    ]
  },
  {
    "clue": [
      "Farm",
      "Aliens",
      "Faith"
    ],
    "answer": "Signs",
    "choices": [
      "Signs",
      "Arrival",
      "Nope",
      "War of the Worlds"
    ]
  },
  {
    "clue": [
      "Clouds",
      "Horses",
      "Spectacle"
    ],
    "answer": "Nope",
    "choices": [
      "Nope",
      "Get Out",
      "Us",
      "Signs"
    ]
  },
  {
    "clue": [
      "Suburb",
      "Hypnosis",
      "Teacup"
    ],
    "answer": "Get Out",
    "choices": [
      "Get Out",
      "Us",
      "Nope",
      "Candyman"
    ]
  },
  {
    "clue": [
      "Doubles",
      "Beach",
      "Scissors"
    ],
    "answer": "Us",
    "choices": [
      "Us",
      "Get Out",
      "Nope",
      "The Strangers"
    ]
  },
  {
    "clue": [
      "Mirror",
      "Curse",
      "Candy"
    ],
    "answer": "Candyman",
    "choices": [
      "Candyman",
      "Get Out",
      "Us",
      "The Ring"
    ]
  },
  {
    "clue": [
      "Videotape",
      "Well",
      "Seven Days"
    ],
    "answer": "The Ring",
    "choices": [
      "The Ring",
      "The Grudge",
      "Pulse",
      "Dark Water"
    ]
  },
  {
    "clue": [
      "Internet",
      "Ghost",
      "Loneliness"
    ],
    "answer": "Pulse",
    "choices": [
      "Pulse",
      "The Ring",
      "Dark Water",
      "Cure"
    ]
  },
  {
    "clue": [
      "Detective",
      "Hypnosis",
      "Murders"
    ],
    "answer": "Cure",
    "choices": [
      "Cure",
      "Pulse",
      "Memories of Murder",
      "Zodiac"
    ]
  },
  {
    "clue": [
      "Letters",
      "Basement",
      "Zodiac"
    ],
    "answer": "Zodiac",
    "choices": [
      "Zodiac",
      "Se7en",
      "Memories of Murder",
      "Prisoners"
    ]
  },
  {
    "clue": [
      "Box",
      "Rain",
      "Sins"
    ],
    "answer": "Se7en",
    "choices": [
      "Se7en",
      "Zodiac",
      "Prisoners",
      "The Silence of the Lambs"
    ]
  },
  {
    "clue": [
      "Moth",
      "Prison",
      "Clarice"
    ],
    "answer": "The Silence of the Lambs",
    "choices": [
      "The Silence of the Lambs",
      "Se7en",
      "Manhunter",
      "Prisoners"
    ]
  },
  {
    "clue": [
      "Missing Child",
      "Maze",
      "Desperation"
    ],
    "answer": "Prisoners",
    "choices": [
      "Prisoners",
      "Zodiac",
      "Gone Girl",
      "Mystic River"
    ]
  },
  {
    "clue": [
      "Marriage",
      "Media",
      "Disappearance"
    ],
    "answer": "Gone Girl",
    "choices": [
      "Gone Girl",
      "Prisoners",
      "The Girl with the Dragon Tattoo",
      "Sharp Objects"
    ]
  },
  {
    "clue": [
      "Hacker",
      "Tattoo",
      "Snow"
    ],
    "answer": "The Girl with the Dragon Tattoo",
    "choices": [
      "The Girl with the Dragon Tattoo",
      "Gone Girl",
      "Zodiac",
      "Prisoners"
    ]
  },
  {
    "clue": [
      "Boston",
      "River",
      "Grief"
    ],
    "answer": "Mystic River",
    "choices": [
      "Mystic River",
      "Gone Baby Gone",
      "Prisoners",
      "Manchester by the Sea"
    ]
  },
  {
    "clue": [
      "Winter",
      "Grief",
      "Uncle"
    ],
    "answer": "Manchester by the Sea",
    "choices": [
      "Manchester by the Sea",
      "Mystic River",
      "Blue Valentine",
      "The Wrestler"
    ]
  },
  {
    "clue": [
      "Marriage",
      "Collapse",
      "Brooklyn"
    ],
    "answer": "Blue Valentine",
    "choices": [
      "Blue Valentine",
      "Marriage Story",
      "Revolutionary Road",
      "Take This Waltz"
    ]
  },
  {
    "clue": [
      "Divorce",
      "Theater",
      "Letters"
    ],
    "answer": "Marriage Story",
    "choices": [
      "Marriage Story",
      "Blue Valentine",
      "Kramer vs. Kramer",
      "The Squid and the Whale"
    ]
  },
  {
    "clue": [
      "Suburban",
      "Dream",
      "Collapse"
    ],
    "answer": "Revolutionary Road",
    "choices": [
      "Revolutionary Road",
      "American Beauty",
      "Blue Valentine",
      "Little Children"
    ]
  },
  {
    "clue": [
      "Wrestling",
      "Daughter",
      "Redemption"
    ],
    "answer": "The Wrestler",
    "choices": [
      "The Wrestler",
      "Foxcatcher",
      "Raging Bull",
      "Creed"
    ]
  },
  {
    "clue": [
      "Boxer",
      "Rage",
      "Black-and-white"
    ],
    "answer": "Raging Bull",
    "choices": [
      "Raging Bull",
      "Rocky",
      "The Wrestler",
      "The Fighter"
    ]
  },
  {
    "clue": [
      "Philly",
      "Steps",
      "Underdog"
    ],
    "answer": "Rocky",
    "choices": [
      "Rocky",
      "Creed",
      "Raging Bull",
      "Million Dollar Baby"
    ]
  },
  {
    "clue": [
      "Boxing",
      "Legacy",
      "Son"
    ],
    "answer": "Creed",
    "choices": [
      "Creed",
      "Rocky",
      "The Fighter",
      "Ali"
    ]
  },
  {
    "clue": [
      "Gym",
      "Brother",
      "Addiction"
    ],
    "answer": "The Fighter",
    "choices": [
      "The Fighter",
      "Creed",
      "Warrior",
      "Foxcatcher"
    ]
  },
  {
    "clue": [
      "Mansion",
      "Wrestling",
      "Wealth"
    ],
    "answer": "Foxcatcher",
    "choices": [
      "Foxcatcher",
      "The Wrestler",
      "Moneyball",
      "Capote"
    ]
  },
  {
    "clue": [
      "Baseball",
      "Math",
      "Oakland"
    ],
    "answer": "Moneyball",
    "choices": [
      "Moneyball",
      "The Social Network",
      "The Big Short",
      "Draft Day"
    ]
  },
  {
    "clue": [
      "Harvard",
      "Code",
      "Betrayal"
    ],
    "answer": "The Social Network",
    "choices": [
      "The Social Network",
      "Steve Jobs",
      "Moneyball",
      "The Big Short"
    ]
  },
  {
    "clue": [
      "Mortgage",
      "Collapse",
      "Comedy"
    ],
    "answer": "The Big Short",
    "choices": [
      "The Big Short",
      "Margin Call",
      "Wall Street",
      "Moneyball"
    ]
  },
  {
    "clue": [
      "Office",
      "Night",
      "Crisis"
    ],
    "answer": "Margin Call",
    "choices": [
      "Margin Call",
      "The Big Short",
      "Wall Street",
      "Michael Clayton"
    ]
  },
  {
    "clue": [
      "Lawyer",
      "Horse",
      "Conspiracy"
    ],
    "answer": "Michael Clayton",
    "choices": [
      "Michael Clayton",
      "The Insider",
      "Spotlight",
      "Erin Brockovich"
    ]
  },
  {
    "clue": [
      "Whistleblower",
      "Tobacco",
      "Truth"
    ],
    "answer": "The Insider",
    "choices": [
      "The Insider",
      "Michael Clayton",
      "Spotlight",
      "The Post"
    ]
  },
  {
    "clue": [
      "Newspaper",
      "Pentagon",
      "Papers"
    ],
    "answer": "The Post",
    "choices": [
      "The Post",
      "Spotlight",
      "All the President's Men",
      "The Insider"
    ]
  },
  {
    "clue": [
      "Watergate",
      "Reporters",
      "Parking"
    ],
    "answer": "All the President's Men",
    "choices": [
      "All the President's Men",
      "The Post",
      "Spotlight",
      "Zodiac"
    ]
  },
  {
    "clue": [
      "Casino",
      "Desert",
      "Betrayal"
    ],
    "answer": "Casino",
    "choices": [
      "Casino",
      "Goodfellas",
      "Heat",
      "Scarface"
    ]
  },
  {
    "clue": [
      "Gangsters",
      "Pasta",
      "Helicopter"
    ],
    "answer": "Goodfellas",
    "choices": [
      "Goodfellas",
      "Casino",
      "The Godfather",
      "A Bronx Tale"
    ]
  },
  {
    "clue": [
      "Family",
      "Crime",
      "Sicily"
    ],
    "answer": "The Godfather",
    "choices": [
      "The Godfather",
      "Goodfellas",
      "Scarface",
      "Once Upon a Time in America"
    ]
  },
  {
    "clue": [
      "Cocaine",
      "Mansion",
      "Chainsaw"
    ],
    "answer": "Scarface",
    "choices": [
      "Scarface",
      "Carlito's Way",
      "Casino",
      "Blow"
    ]
  },
  {
    "clue": [
      "Mob",
      "Memory",
      "Noodles"
    ],
    "answer": "Once Upon a Time in America",
    "choices": [
      "Once Upon a Time in America",
      "The Godfather Part II",
      "Goodfellas",
      "Casino"
    ]
  },
  {
    "clue": [
      "Bank Heist",
      "Coffee",
      "LA"
    ],
    "answer": "Heat",
    "choices": [
      "Heat",
      "Collateral",
      "Thief",
      "Ronin"
    ]
  },
  {
    "clue": [
      "Jewels",
      "Safe",
      "Neon"
    ],
    "answer": "Thief",
    "choices": [
      "Thief",
      "Heat",
      "Drive",
      "Collateral"
    ]
  },
  {
    "clue": [
      "Samurai",
      "Hitman",
      "Paris"
    ],
    "answer": "Le Samouraï",
    "choices": [
      "Le Samouraï",
      "Thief",
      "Drive",
      "Rififi"
    ]
  },
  {
    "clue": [
      "Silent Heist",
      "Paris",
      "Jewels"
    ],
    "answer": "Rififi",
    "choices": [
      "Rififi",
      "Le Samouraï",
      "Bob le Flambeur",
      "The Killing"
    ]
  },
  {
    "clue": [
      "Horse Racetrack",
      "Heist",
      "Timing"
    ],
    "answer": "The Killing",
    "choices": [
      "The Killing",
      "Rififi",
      "Reservoir Dogs",
      "The Asphalt Jungle"
    ]
  },
  {
    "clue": [
      "Color Names",
      "Warehouse",
      "Betrayal"
    ],
    "answer": "Reservoir Dogs",
    "choices": [
      "Reservoir Dogs",
      "Pulp Fiction",
      "The Killing",
      "Jackie Brown"
    ]
  },
  {
    "clue": [
      "Flight Attendant",
      "Smuggling",
      "Money"
    ],
    "answer": "Jackie Brown",
    "choices": [
      "Jackie Brown",
      "Pulp Fiction",
      "Out of Sight",
      "Foxy Brown"
    ]
  },
  {
    "clue": [
      "Detroit",
      "Romance",
      "Briefcase"
    ],
    "answer": "True Romance",
    "choices": [
      "True Romance",
      "Pulp Fiction",
      "Natural Born Killers",
      "Badlands"
    ]
  },
  {
    "clue": [
      "Lovers",
      "Desert",
      "Crime"
    ],
    "answer": "Badlands",
    "choices": [
      "Badlands",
      "True Romance",
      "Bonnie and Clyde",
      "Days of Heaven"
    ]
  },
  {
    "clue": [
      "Wheat Fields",
      "Love Triangle",
      "Fire"
    ],
    "answer": "Days of Heaven",
    "choices": [
      "Days of Heaven",
      "Badlands",
      "The Tree of Life",
      "Paris, Texas"
    ]
  },
  {
    "clue": [
      "Texas",
      "Desert",
      "Phone Booth"
    ],
    "answer": "Paris, Texas",
    "choices": [
      "Paris, Texas",
      "Wings of Desire",
      "Badlands",
      "The Straight Story"
    ]
  },
  {
    "clue": [
      "Angels",
      "Berlin",
      "Trapeze"
    ],
    "answer": "Wings of Desire",
    "choices": [
      "Wings of Desire",
      "Paris, Texas",
      "Until the End of the World",
      "The American Friend"
    ]
  },
  {
    "clue": [
      "Karaoke Bar",
      "Hitman",
      "Night"
    ],
    "answer": "Fallen Angels",
    "choices": [
      "Fallen Angels",
      "Chungking Express",
      "Happy Together",
      "As Tears Go By"
    ]
  },
  {
    "clue": [
      "Argentina",
      "Lovers",
      "Road"
    ],
    "answer": "Happy Together",
    "choices": [
      "Happy Together",
      "Fallen Angels",
      "In the Mood for Love",
      "Chungking Express"
    ]
  },
  {
    "clue": [
      "Circus",
      "Fish",
      "Father"
    ],
    "answer": "Big Fish",
    "choices": [
      "Big Fish",
      "Edward Scissorhands",
      "Forrest Gump",
      "Amélie"
    ]
  },
  {
    "clue": [
      "Suburb",
      "Scissors",
      "Snow"
    ],
    "answer": "Edward Scissorhands",
    "choices": [
      "Edward Scissorhands",
      "Big Fish",
      "Beetlejuice",
      "Sleepy Hollow"
    ]
  },
  {
    "clue": [
      "Ghost Couple",
      "Handbook",
      "House"
    ],
    "answer": "Beetlejuice",
    "choices": [
      "Beetlejuice",
      "Edward Scissorhands",
      "Ghostbusters",
      "The Addams Family"
    ]
  },
  {
    "clue": [
      "Montmartre",
      "Kindness",
      "Gnome"
    ],
    "answer": "Amélie",
    "choices": [
      "Amélie",
      "Chocolat",
      "Midnight in Paris",
      "The Science of Sleep"
    ]
  },
  {
    "clue": [
      "Cardboard",
      "Dreams",
      "Paris"
    ],
    "answer": "The Science of Sleep",
    "choices": [
      "The Science of Sleep",
      "Eternal Sunshine of the Spotless Mind",
      "Amélie",
      "Mood Indigo"
    ]
  },
  {
    "clue": [
      "Typewriter",
      "Surreal",
      "Love"
    ],
    "answer": "Mood Indigo",
    "choices": [
      "Mood Indigo",
      "The Science of Sleep",
      "Amélie",
      "Holy Motors"
    ]
  },
  {
    "clue": [
      "Limousine",
      "Masks",
      "Paris"
    ],
    "answer": "Holy Motors",
    "choices": [
      "Holy Motors",
      "Annette",
      "Titane",
      "The Lobster"
    ]
  },
  {
    "clue": [
      "Hotel",
      "Singles",
      "Animals"
    ],
    "answer": "The Lobster",
    "choices": [
      "The Lobster",
      "Dogtooth",
      "Poor Things",
      "Kinds of Kindness"
    ]
  },
  {
    "clue": [
      "Family Rules",
      "Teeth",
      "Control"
    ],
    "answer": "Dogtooth",
    "choices": [
      "Dogtooth",
      "The Lobster",
      "Poor Things",
      "Alps"
    ]
  },
  {
    "clue": [
      "Victorian",
      "Body",
      "Freedom"
    ],
    "answer": "Poor Things",
    "choices": [
      "Poor Things",
      "The Favourite",
      "The Lobster",
      "Barbie"
    ]
  },
  {
    "clue": [
      "Court",
      "Rabbits",
      "Power"
    ],
    "answer": "The Favourite",
    "choices": [
      "The Favourite",
      "Poor Things",
      "Marie Antoinette",
      "Amadeus"
    ]
  },
  {
    "clue": [
      "Pink Palace",
      "Queen",
      "Pop"
    ],
    "answer": "Marie Antoinette",
    "choices": [
      "Marie Antoinette",
      "The Favourite",
      "Priscilla",
      "Emma."
    ]
  },
  {
    "clue": [
      "Opera",
      "Genius",
      "Rivalry"
    ],
    "answer": "Amadeus",
    "choices": [
      "Amadeus",
      "Tár",
      "The Piano",
      "The Red Shoes"
    ]
  },
  {
    "clue": [
      "Conductor",
      "Power",
      "Scandal"
    ],
    "answer": "Tár",
    "choices": [
      "Tár",
      "Whiplash",
      "Black Swan",
      "Amadeus"
    ]
  },
  {
    "clue": [
      "Ballet",
      "Red Shoes",
      "Obsession"
    ],
    "answer": "The Red Shoes",
    "choices": [
      "The Red Shoes",
      "Black Swan",
      "Suspiria",
      "The Umbrellas of Cherbourg"
    ]
  },
  {
    "clue": [
      "Umbrellas",
      "Color",
      "War"
    ],
    "answer": "The Umbrellas of Cherbourg",
    "choices": [
      "The Umbrellas of Cherbourg",
      "La La Land",
      "The Young Girls of Rochefort",
      "Amélie"
    ]
  },
  {
    "clue": [
      "Sailors",
      "Rochefort",
      "Sisters"
    ],
    "answer": "The Young Girls of Rochefort",
    "choices": [
      "The Young Girls of Rochefort",
      "The Umbrellas of Cherbourg",
      "La La Land",
      "An American in Paris"
    ]
  },
  {
    "clue": [
      "Painting",
      "Paris",
      "Dance"
    ],
    "answer": "An American in Paris",
    "choices": [
      "An American in Paris",
      "Singin' in the Rain",
      "La La Land",
      "Funny Face"
    ]
  },
  {
    "clue": [
      "Hollywood",
      "Rain",
      "Smile"
    ],
    "answer": "Singin' in the Rain",
    "choices": [
      "Singin' in the Rain",
      "An American in Paris",
      "The Artist",
      "La La Land"
    ]
  },
  {
    "clue": [
      "Silent Star",
      "Dog",
      "Fame"
    ],
    "answer": "The Artist",
    "choices": [
      "The Artist",
      "Singin' in the Rain",
      "Sunset Boulevard",
      "Babylon"
    ]
  },
  {
    "clue": [
      "Mansion",
      "Norma",
      "Descent"
    ],
    "answer": "Sunset Boulevard",
    "choices": [
      "Sunset Boulevard",
      "The Artist",
      "All About Eve",
      "Mulholland Drive"
    ]
  },
  {
    "clue": [
      "Theater",
      "Rivalry",
      "Fame"
    ],
    "answer": "All About Eve",
    "choices": [
      "All About Eve",
      "Sunset Boulevard",
      "Birdman",
      "Opening Night"
    ]
  },
  {
    "clue": [
      "Backstage",
      "Breakdown",
      "Actress"
    ],
    "answer": "Opening Night",
    "choices": [
      "Opening Night",
      "All About Eve",
      "Birdman",
      "Persona"
    ]
  },
  {
    "clue": [
      "Broadway",
      "Drums",
      "Bird"
    ],
    "answer": "Birdman",
    "choices": [
      "Birdman",
      "Whiplash",
      "All That Jazz",
      "Opening Night"
    ]
  },
  {
    "clue": [
      "Director",
      "Hospital",
      "Musical"
    ],
    "answer": "All That Jazz",
    "choices": [
      "All That Jazz",
      "Birdman",
      "8½",
      "Cabaret"
    ]
  },
  {
    "clue": [
      "Director",
      "Memory",
      "Circus"
    ],
    "answer": "8½",
    "choices": [
      "8½",
      "All That Jazz",
      "Cinema Paradiso",
      "La Dolce Vita"
    ]
  },
  {
    "clue": [
      "Rome",
      "Fountain",
      "Celebrity"
    ],
    "answer": "La Dolce Vita",
    "choices": [
      "La Dolce Vita",
      "8½",
      "Roman Holiday",
      "The Great Beauty"
    ]
  },
  {
    "clue": [
      "Rome",
      "Parties",
      "Aging"
    ],
    "answer": "The Great Beauty",
    "choices": [
      "The Great Beauty",
      "La Dolce Vita",
      "Youth",
      "8½"
    ]
  },
  {
    "clue": [
      "Princess",
      "Rome",
      "Vespa"
    ],
    "answer": "Roman Holiday",
    "choices": [
      "Roman Holiday",
      "La Dolce Vita",
      "Breakfast at Tiffany's",
      "Sabrina"
    ]
  },
  {
    "clue": [
      "Cat",
      "Window",
      "New York"
    ],
    "answer": "Breakfast at Tiffany's",
    "choices": [
      "Breakfast at Tiffany's",
      "Roman Holiday",
      "Sabrina",
      "Funny Face"
    ]
  },
  {
    "clue": [
      "Fashion",
      "Paris",
      "Bookstore"
    ],
    "answer": "Funny Face",
    "choices": [
      "Funny Face",
      "Sabrina",
      "Breakfast at Tiffany's",
      "Charade"
    ]
  },
  {
    "clue": [
      "Spy",
      "Paris",
      "Stamps"
    ],
    "answer": "Charade",
    "choices": [
      "Charade",
      "North by Northwest",
      "To Catch a Thief",
      "Sabrina"
    ]
  },
  {
    "clue": [
      "Crop Duster",
      "Wrong Man",
      "Train"
    ],
    "answer": "North by Northwest",
    "choices": [
      "North by Northwest",
      "Vertigo",
      "Rear Window",
      "Charade"
    ]
  },
  {
    "clue": [
      "Photographer",
      "Window",
      "Suspicion"
    ],
    "answer": "Rear Window",
    "choices": [
      "Rear Window",
      "Vertigo",
      "Psycho",
      "Blow-Up"
    ]
  },
  {
    "clue": [
      "Blonde",
      "Spiral",
      "Obsession"
    ],
    "answer": "Vertigo",
    "choices": [
      "Vertigo",
      "Rear Window",
      "Psycho",
      "Rebecca"
    ]
  },
  {
    "clue": [
      "Motel",
      "Shower",
      "Mother"
    ],
    "answer": "Psycho",
    "choices": [
      "Psycho",
      "Vertigo",
      "Rear Window",
      "Peeping Tom"
    ]
  },
  {
    "clue": [
      "Camera",
      "Killer",
      "Voyeur"
    ],
    "answer": "Peeping Tom",
    "choices": [
      "Peeping Tom",
      "Psycho",
      "Blow-Up",
      "Rear Window"
    ]
  },
  {
    "clue": [
      "Shark",
      "Beach",
      "Summer"
    ],
    "answer": "Jaws",
    "choices": [
      "Jaws",
      "The Birds",
      "Alien",
      "Jurassic Park"
    ]
  },
  {
    "clue": [
      "Birds",
      "School",
      "Attack"
    ],
    "answer": "The Birds",
    "choices": [
      "The Birds",
      "Jaws",
      "Psycho",
      "The Mist"
    ]
  },
  {
    "clue": [
      "Space Truck",
      "Monster",
      "Ship"
    ],
    "answer": "Alien",
    "choices": [
      "Alien",
      "Aliens",
      "The Thing",
      "Event Horizon"
    ]
  },
  {
    "clue": [
      "Antarctica",
      "Paranoia",
      "Creature"
    ],
    "answer": "The Thing",
    "choices": [
      "The Thing",
      "Alien",
      "The Fly",
      "The Mist"
    ]
  },
  {
    "clue": [
      "Scientist",
      "Insect",
      "Transformation"
    ],
    "answer": "The Fly",
    "choices": [
      "The Fly",
      "The Thing",
      "Videodrome",
      "Scanners"
    ]
  },
  {
    "clue": [
      "Television",
      "Flesh",
      "Signal"
    ],
    "answer": "Videodrome",
    "choices": [
      "Videodrome",
      "The Fly",
      "eXistenZ",
      "Scanners"
    ]
  },
  {
    "clue": [
      "Game Pod",
      "Reality",
      "Body"
    ],
    "answer": "eXistenZ",
    "choices": [
      "eXistenZ",
      "Videodrome",
      "The Matrix",
      "Naked Lunch"
    ]
  },
  {
    "clue": [
      "Typewriter",
      "Bugs",
      "Addiction"
    ],
    "answer": "Naked Lunch",
    "choices": [
      "Naked Lunch",
      "Videodrome",
      "Brazil",
      "Fear and Loathing in Las Vegas"
    ]
  },
  {
    "clue": [
      "Bureaucracy",
      "Ducts",
      "Dream"
    ],
    "answer": "Brazil",
    "choices": [
      "Brazil",
      "1984",
      "The Trial",
      "Dark City"
    ]
  },
  {
    "clue": [
      "Clock City",
      "Nightmare",
      "Memory"
    ],
    "answer": "Dark City",
    "choices": [
      "Dark City",
      "The Matrix",
      "Brazil",
      "Equilibrium"
    ]
  },
  {
    "clue": [
      "Memory",
      "Tattoos",
      "Revenge"
    ],
    "answer": "Memento",
    "choices": [
      "Memento",
      "Insomnia",
      "The Prestige",
      "Following"
    ]
  },
  {
    "clue": [
      "Magicians",
      "Tesla",
      "Rivalry"
    ],
    "answer": "The Prestige",
    "choices": [
      "The Prestige",
      "Memento",
      "The Illusionist",
      "Inception"
    ]
  },
  {
    "clue": [
      "Insomnia",
      "Alaska",
      "Murder"
    ],
    "answer": "Insomnia",
    "choices": [
      "Insomnia",
      "Memento",
      "Zodiac",
      "Wind River"
    ]
  },
  {
    "clue": [
      "Snow",
      "Reservation",
      "Mystery"
    ],
    "answer": "Wind River",
    "choices": [
      "Wind River",
      "Insomnia",
      "Prisoners",
      "Fargo"
    ]
  },
  {
    "clue": [
      "Minnesota",
      "Snow",
      "Crime"
    ],
    "answer": "Fargo",
    "choices": [
      "Fargo",
      "Wind River",
      "A Simple Plan",
      "No Country for Old Men"
    ]
  },
  {
    "clue": [
      "Texas",
      "Money",
      "Killer"
    ],
    "answer": "No Country for Old Men",
    "choices": [
      "No Country for Old Men",
      "Fargo",
      "Blood Simple",
      "Hell or High Water"
    ]
  },
  {
    "clue": [
      "Brothers",
      "Banks",
      "Texas"
    ],
    "answer": "Hell or High Water",
    "choices": [
      "Hell or High Water",
      "No Country for Old Men",
      "Wind River",
      "Sicario"
    ]
  },
  {
    "clue": [
      "Border",
      "Dust",
      "Cartel"
    ],
    "answer": "Sicario",
    "choices": [
      "Sicario",
      "Traffic",
      "Hell or High Water",
      "No Country for Old Men"
    ]
  },
  {
    "clue": [
      "Drugs",
      "Border",
      "Families"
    ],
    "answer": "Traffic",
    "choices": [
      "Traffic",
      "Sicario",
      "Babel",
      "Syriana"
    ]
  },
  {
    "clue": [
      "Multiple Stories",
      "Crash",
      "Distance"
    ],
    "answer": "Babel",
    "choices": [
      "Babel",
      "Traffic",
      "Amores Perros",
      "21 Grams"
    ]
  },
  {
    "clue": [
      "Dogs",
      "Mexico",
      "Crash"
    ],
    "answer": "Amores Perros",
    "choices": [
      "Amores Perros",
      "Babel",
      "21 Grams",
      "City of God"
    ]
  },
  {
    "clue": [
      "Favela",
      "Boys",
      "Camera"
    ],
    "answer": "City of God",
    "choices": [
      "City of God",
      "Amores Perros",
      "Elite Squad",
      "Pixote"
    ]
  },
  {
    "clue": [
      "Motorcycle",
      "Diaries",
      "Youth"
    ],
    "answer": "The Motorcycle Diaries",
    "choices": [
      "The Motorcycle Diaries",
      "Y Tu Mamá También",
      "Roma",
      "Central Station"
    ]
  },
  {
    "clue": [
      "Road Trip",
      "Mexico",
      "Desire"
    ],
    "answer": "Y Tu Mamá También",
    "choices": [
      "Y Tu Mamá También",
      "The Motorcycle Diaries",
      "Roma",
      "Amores Perros"
    ]
  },
  {
    "clue": [
      "Maid",
      "Beach",
      "Memory"
    ],
    "answer": "Roma",
    "choices": [
      "Roma",
      "Y Tu Mamá También",
      "Central Station",
      "The Virgin Suicides"
    ]
  },
  {
    "clue": [
      "Train",
      "Letters",
      "Brazil"
    ],
    "answer": "Central Station",
    "choices": [
      "Central Station",
      "Roma",
      "The Motorcycle Diaries",
      "City of God"
    ]
  },
  {
    "clue": [
      "Sisters",
      "Suburbia",
      "Tragedy"
    ],
    "answer": "The Virgin Suicides",
    "choices": [
      "The Virgin Suicides",
      "Marie Antoinette",
      "Picnic at Hanging Rock",
      "Mustang"
    ]
  },
  {
    "clue": [
      "Girls",
      "School",
      "Disappearance"
    ],
    "answer": "Picnic at Hanging Rock",
    "choices": [
      "Picnic at Hanging Rock",
      "The Virgin Suicides",
      "Mustang",
      "The Piano"
    ]
  },
  {
    "clue": [
      "Sisters",
      "Rebellion",
      "Turkey"
    ],
    "answer": "Mustang",
    "choices": [
      "Mustang",
      "The Virgin Suicides",
      "Girlhood",
      "Persepolis"
    ],
    },
];

export default movieGamePuzzles;
